import Vue from 'vue'
import store from '@/store/store'

import Vuelidate from 'vuelidate'
import Notifications from 'vue-notification'
import vuexI18n from 'vuex-i18n'
// Axios
import axios from 'axios'
// библиотека для работы с localstorage
import VueLocalStorage from '@vue-helpers/vue-local-storage'
// Директива для "ленивой" загрузки изображений
import VueImageLazyLoad from '@vue-helpers/vue-image-lazyload'
// Директива для определение элемента во вьюпорте
import VueObserveVisibility from 'vue-observe-visibility'
import './vModal'
import './zendesk'
// Стили для плагина vSelect
import 'vue-select/dist/vue-select.css'

Vue.use(Vuelidate)
Vue.use(Notifications)
// библиотека для работы с localstorage
Vue.use(VueLocalStorage)
// Директива для "ленивой" загрузки изображений
Vue.use(VueImageLazyLoad)
// Директива для определение элемента во вьюпорте
Vue.use(VueObserveVisibility)

const i18nConfig = {
  onTranslationNotFound: (loc, key) => {
    Vue.i18n.add(loc, { [key]: '' })
  }
}

Vue.use(vuexI18n.plugin, store, i18nConfig)
Vue.i18n.set(window.translationParams.language)
// TODO: Remove after make all request from custom api client
axios.defaults.headers.common['x-csrf-token'] = document.head.querySelector('meta[name="csrf-token"]').content
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
